import React from 'react'

import { CircularProgress } from '@mui/material'
import isEmpty from 'lodash/isEmpty'

import TopicRefinementButton from 'components/TopicRefinementButton'
import TopicRefinementResponse from 'components/TopicRefinementResponse'

import useTopicRefinement from 'hooks/useTopicRefinement'

export const TEST_ID = 'TopicRefinementSection'

export type Props = {
	backgroundColor?: string
	businessProblem: string
	companyName: string
	customGame: boolean
	dataTestId?: string
}

const TopicRefinementSection = ({
	businessProblem,
	companyName,
	customGame,
	dataTestId = 'topic-refinement-section',
	backgroundColor,
}: Props) => {
	const {
		aiResponse,
		clearResponse,
		loading: refinementLoading,
		requestRefinement,
	} = useTopicRefinement()

	return (
		<>
			<TopicRefinementButton
				promptText={businessProblem}
				onClick={() => {
					requestRefinement(businessProblem, companyName)
				}}
				dataTestId={`${dataTestId}__topic-refinement-button`}
				customGame={customGame}
			/>
			{refinementLoading && (
				<CircularProgress
					data-testid={`${dataTestId}__topic-refinement-loading`}
					size={24}
				/>
			)}
			{!isEmpty(aiResponse) && (
				<TopicRefinementResponse
					contentText={aiResponse}
					clearResponse={clearResponse}
					data-testid={`${dataTestId}__topic-refinement-response`}
					backgroundColor={backgroundColor}
				/>
			)}
		</>
	)
}

export default TopicRefinementSection
